import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaInstagram } from 'react-icons/fa';

const ArtistsSection = styled.section`
  padding: 6rem 2rem 4rem;
  background-color: var(--dark-gray);
`;

const SectionTitle = styled.h2`
  font-family: 'Blackwood Castle', serif;
  font-size: 3rem;
  color: var(--gold);
  text-align: center;
  margin-bottom: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const ArtistsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ArtistCard = styled.div`
  width: 350px;
  background-color: var(--royal-blue);
  border: 2px solid var(--gold);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-10px);
  }

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 1px solid var(--gold);
    pointer-events: none;
    opacity: 0.5;
    z-index: 1;
    border-radius: 8px;
  }
`;

const ArtistImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-bottom: 2px solid var(--gold);
`;

const ArtistInfo = styled.div`
  padding: 1.5rem;
`;

const ArtistName = styled.h3`
  font-family: 'Blackwood Castle', serif;
  font-size: 1.8rem;
  color: var(--gold);
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ArtistSpecialties = styled.p`
  color: var(--white);
  font-size: 1rem;
  margin-bottom: 1.5rem;
  line-height: 1.4;
`;

const WorksTitle = styled.h4`
  font-family: 'Blackwood Castle', serif;
  font-size: 1.2rem;
  color: var(--gold);
  margin-bottom: 1rem;
  text-align: center;
`;

const StyledSlider = styled(Slider)`
  .slick-prev, .slick-next {
    z-index: 1;
    &:before {
      color: var(--gold);
      font-size: 24px;
    }
  }

  .slick-prev {
    left: 5px;
  }

  .slick-next {
    right: 5px;
  }

  .slick-dots {
    bottom: -30px;
    
    li button:before {
      color: var(--gold);
    }
    
    li.slick-active button:before {
      color: var(--gold);
    }
  }
`;

const WorkImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  padding: 0 5px;
`;

const InstagramLink = styled.a`
  color: var(--gold);
  font-size: 1.5rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--gold);
  }
`;

const Artists = () => {
  const artistsData = [
    {
      id: 1,
      name: 'Georges',
      instagram: 'https://www.instagram.com/Jorj_art',
      specialties: 'Realism, Black and Grey Realism',
      image: '/images/Georges_web.jpg',
      works: [
        '/images/Georges_tattoo1_web.jpeg',
        '/images/Georges_tattoo2_web.jpeg',
        '/images/Georges_tattoo3_web.jpeg'
      ]
    },
    {
      id: 2,
      name: 'Viktor',
      instagram: 'https://www.instagram.com/viktor_artisan',
      specialties: 'Réalisme, Réalisme en couleurs, Black and Grey Realism, FineLine, Chicano, Polyvalent',
      image: '/images/Viktor_web.jpg',
      works: [
        '/images/Viktors_tattoo1_web.jpeg',
        '/images/Viktors_tattoo2_web.jpeg',
        '/images/Viktors_tattoo3_web.jpeg'
      ]
    },
    {
      id: 3,
      name: 'Marie',
      instagram: 'https://www.instagram.com/mariesexprime_ttt',
      specialties: 'Bousille, Pointillisme, Minimaliste, Ignorant, Lettrage traditionnelle, Trad Français',
      image: '/images/Marie_web.jpg',
      works: [
        '/images/Marie_tattoo1_web.jpeg',
        '/images/Marie_tattoo2_web.jpeg',
        '/images/Marie_tattoo3_web.jpeg'
      ]
    },
    {
      id: 4,
      name: 'David',
      instagram: 'https://www.instagram.com/david_gos_tattoo',
      specialties: 'Realisme, Black and Grey, Grey wash, Géométrique et ornemental, Polyvalent',
      image: '/images/David_web.jpg',
      works: [
        '/images/David_tattoo1_web.jpeg',
        '/images/David_tattoo2_web.jpeg',
        '/images/David_tattoo3_web.jpeg'
      ]
    },
    {
      id: 5,
      name: 'Juan',
      instagram: 'https://www.instagram.com/_gatonegro_tattooc',
      specialties: 'Fine Line, Ornemental, Grey wash, Trad Américain, Trad Japonais',
      image: '/images/Juan_web.jpg',
      works: [
        '/images/juan_tattoo1_web.jpeg',
        '/images/juan_tattoo2_web.jpeg',
        '/images/juan_tattoo3_web.jpeg'
      ]
    },
    {
      id: 6,
      name: 'Nicolas',
      instagram: 'https://www.instagram.com/ink_o_nito',
      specialties: 'Sketching, Fineline, Ornemental',
      image: '/images/Nicola_web.jpg',
      works: [
        '/images/Nicolas_tattoo1_web.jpeg',
        '/images/Nicolas_tattoo2_web.jpeg',
        '/images/Nicolas_tattoo3_web.jpeg'
      ]
    },
    {
      id: 7,
      name: 'Makida',
      instagram: 'https://www.instagram.com/knfactory_',
      specialties: 'Piercing',
      image: '/images/Makida_web.jpg',
      works: [
        '/images/Makida_work1_web.jpeg',
        '/images/Makida_work2_web.jpeg',
        '/images/Makida_work3_web.jpeg',
        '/images/Makida_work4_web.jpeg',
        '/images/Makida_work5_web.jpeg'
      ]
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <ArtistsSection id="artistes">
      <SectionTitle>Nos Artistes</SectionTitle>
      <ArtistsContainer>
        {artistsData.map((artist) => (
          <ArtistCard key={artist.id}>
            <ArtistImage src={artist.image} alt={artist.name} />
            <ArtistInfo>
              <ArtistName>
                {artist.name}
                <InstagramLink href={artist.instagram} target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </InstagramLink>
              </ArtistName>
              <ArtistSpecialties>{artist.specialties}</ArtistSpecialties>
              <WorksTitle>Réalisations</WorksTitle>
              <StyledSlider {...sliderSettings}>
                {artist.works.map((work, index) => (
                  <div key={index}>
                    <WorkImage src={work} alt={`${artist.name} work ${index + 1}`} />
                  </div>
                ))}
              </StyledSlider>
            </ArtistInfo>
          </ArtistCard>
        ))}
      </ArtistsContainer>
    </ArtistsSection>
  );
};

export default Artists;
